import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "flex items-center justify-between mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "max-h-96 overflow-y-auto border border-gray-200 dark:border-gray-600 rounded-xl p-3 bg-gray-50 dark:bg-gray-700/50"
}
const _hoisted_7 = { class: "flex items-center gap-3" }
const _hoisted_8 = { class: "flex-shrink-0 text-gray-400 dark:text-gray-500 group-hover:text-blue-500 dark:group-hover:text-blue-400 transition-colors" }
const _hoisted_9 = { class: "flex-shrink-0 w-8 h-8 bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-200 rounded-full flex items-center justify-center text-sm font-semibold" }
const _hoisted_10 = { class: "flex-1 min-w-0" }
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = ["title"]
const _hoisted_15 = ["title"]
const _hoisted_16 = {
  key: 1,
  class: "p-6 text-center border border-gray-200 dark:border-gray-600 rounded-xl bg-gray-50 dark:bg-gray-700/50"
}
const _hoisted_17 = {
  key: 0,
  class: "flex items-center justify-center text-gray-500 dark:text-gray-400"
}
const _hoisted_18 = {
  key: 1,
  class: "text-gray-500 dark:text-gray-400"
}
const _hoisted_19 = { class: "form-group mt-8" }
const _hoisted_20 = { class: "p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-xl h-96 overflow-hidden flex flex-col" }
const _hoisted_21 = { class: "text-sm font-medium text-blue-800 dark:text-blue-200 mb-3 flex items-center gap-2" }
const _hoisted_22 = {
  key: 2,
  class: "text-xs opacity-75"
}
const _hoisted_23 = {
  key: 0,
  class: "text-sm mb-3 p-3 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-lg border border-blue-200 dark:border-blue-700"
}
const _hoisted_24 = { class: "flex flex-wrap gap-4 text-blue-700 dark:text-blue-300" }
const _hoisted_25 = { class: "flex items-center gap-1" }
const _hoisted_26 = { class: "font-bold text-blue-800 dark:text-blue-200" }
const _hoisted_27 = { class: "flex items-center gap-1" }
const _hoisted_28 = { class: "font-bold text-emerald-800 dark:text-emerald-200" }
const _hoisted_29 = {
  key: 1,
  class: "text-sm text-gray-500 dark:text-gray-400 text-center py-8 bg-gray-50 dark:bg-gray-800/30 rounded-lg border border-gray-200 dark:border-gray-600"
}
const _hoisted_30 = {
  key: 2,
  class: "flex-1 flex flex-col overflow-hidden"
}
const _hoisted_31 = { class: "flex-1 overflow-y-auto border border-blue-200 dark:border-blue-700 rounded-lg p-2 pb-3 bg-white dark:bg-gray-800/50" }
const _hoisted_32 = { class: "space-y-1" }
const _hoisted_33 = { class: "flex items-center gap-2 w-full" }
const _hoisted_34 = ["title"]
const _hoisted_35 = ["title"]
const _hoisted_36 = {
  key: 0,
  class: "text-xs text-blue-600 dark:text-blue-400 text-center py-2 italic border-t border-blue-200 dark:border-blue-700 mt-2 pt-2"
}
const _hoisted_37 = {
  key: 0,
  class: "p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl"
}
const _hoisted_38 = { class: "flex items-start gap-3" }
const _hoisted_39 = { class: "text-sm text-red-700 dark:text-red-300 mt-1" }

import { ref, computed, watch, onMounted } from 'vue'
import { Eye, RefreshCw, AlertCircle, Loader2, GripVertical, RotateCcw, Database, Calendar } from 'lucide-vue-next'
import { VueDraggable } from 'vue-draggable-plus'
import BaseModal from '@/components/common/BaseModal.vue'
import BaseButton from '@/components/common/BaseButton.vue'
import BaseInput from '@/components/common/BaseInput.vue'
import { useResponsive } from '@/composables/ui/useResponsive'
import ModulesService, { type CalibratePayload, type CalibrateResponse, type Module } from '@/services/modules'

interface Props {
  isVisible: boolean
}

interface Emits {
  close: []
  success: [message: string]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CalibrateModules',
  props: {
    isVisible: { type: Boolean }
  },
  emits: ["close", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

// Responsive utilities for mobile detection
const { isMobile } = useResponsive()

// Current year for validation
const currentYear = new Date().getFullYear()

// Form state - Set cycles to 10 for indefinite cycles
const form = ref<CalibratePayload>({
  start_month: 1, // January
  start_year: currentYear,
  cycles: 10 // Standard for indefinite cycles
})

// Loading states
const loading = computed(() => syncing.value || previewing.value)
const syncing = ref(false)
const previewing = ref(false)
const loadingModules = ref(false)

// Error and preview states
const error = ref<string | null>(null)
const previewResults = ref<CalibrateResponse | null>(null)

// Module management
const availableModules = ref<Module[]>([])

// Month options for BaseInput select
const months = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' }
]

// Year options for BaseInput select - from current year to 10 years in the future
const yearOptions = Array.from({ length: 11 }, (_, i) => ({
  value: currentYear + i,
  label: (currentYear + i).toString()
}))

// Computed preview data
const previewData = computed(() => {
  if (!previewResults.value) return []
  return previewResults.value.preview || previewResults.value.settings || []
})

// Load available active modules
const loadAvailableModules = async () => {
  try {
    loadingModules.value = true
    error.value = null
    
    const modules = await ModulesService.getActiveModules()
    
    // Sort modules by time settings first (if they exist), then by module_id
    availableModules.value = modules.sort((a, b) => {
      // If both modules have time settings, sort by start date
      if (a.time_setting && b.time_setting) {
        const aStartDate = new Date(a.time_setting.start_date).getTime()
        const bStartDate = new Date(b.time_setting.start_date).getTime()
        
        if (aStartDate !== bStartDate) {
          return aStartDate - bStartDate // Ascending order by start date
        } else {
          // If start dates are the same, fall back to module_id
          return a.module_id - b.module_id
        }
      }
      
      // Modules with time settings come first
      if (a.time_setting && !b.time_setting) {
        return -1
      }
      if (!a.time_setting && b.time_setting) {
        return 1
      }
      
      // If both don't have time settings, sort by module_id
      return a.module_id - b.module_id
    })
    
    // Auto-load preview once modules are loaded
    if (props.isVisible && availableModules.value.length > 0) {
      // Small delay to ensure DOM updates
      setTimeout(() => {
        handlePreview()
      }, 300)
    }
  } catch (err: any) {
    error.value = err.message || 'Failed to load modules'
    availableModules.value = []
  } finally {
    loadingModules.value = false
  }
}

// Load modules when modal opens
onMounted(() => {
  loadAvailableModules()
})

// Reset form when modal is opened
watch(() => props.isVisible, (isVisible) => {
  if (isVisible) {
    form.value = {
      start_month: 1,
      start_year: currentYear,
      cycles: 50 // Standard for indefinite cycles
    }
    error.value = null
    previewResults.value = null
    loadAvailableModules()
  } else {
    // Clear timeout when modal closes
    if (previewTimeout) {
      clearTimeout(previewTimeout)
      previewTimeout = null
    }
  }
})

// Auto-update preview when module order changes
let previewTimeout: number | null = null

watch(
  () => availableModules.value.map(module => module.module_id),
  async (newOrder, oldOrder) => {
    // Clear existing timeout
    if (previewTimeout) {
      clearTimeout(previewTimeout)
    }

    // Only trigger if modules are loaded and order actually changed
    if (
      props.isVisible && 
      availableModules.value.length > 0 && 
      newOrder.length === oldOrder?.length &&
      JSON.stringify(newOrder) !== JSON.stringify(oldOrder)
    ) {
      // Debounce the preview update by 800ms to avoid too many API calls
      previewTimeout = setTimeout(async () => {
        await handlePreview()
      }, 800)
    }
  },
  { deep: true }
)

// Auto-update preview when form settings change
watch(
  () => ({ ...form.value }),
  async (newForm, oldForm) => {
    // Clear existing timeout
    if (previewTimeout) {
      clearTimeout(previewTimeout)
    }

    // Only trigger if form actually changed
    if (
      props.isVisible && 
      availableModules.value.length > 0 && 
      JSON.stringify(newForm) !== JSON.stringify(oldForm)
    ) {
      // Debounce the preview update by 1000ms for form changes
      previewTimeout = setTimeout(async () => {
        await handlePreview()
      }, 1000)
    }
  },
  { deep: true }
)

// Helper function to format date range for modules
const formatModuleDateRange = (startDate: string, endDate: string) => {
  const start = new Date(startDate).toLocaleDateString()
  const end = new Date(endDate).toLocaleDateString()
  return `${start} - ${end}`
}

// Helper function to get dynamic classes for preview items
const getPreviewItemClasses = (index: number) => {
  // Default neutral styles
  const neutral = 'bg-transparent dark:bg-transparent text-slate-700 dark:text-slate-300 rounded-md border-l-4'

  // Permanent border colors per scheme (visible even when not hovered)
  const borderSchemes = [
    'border-blue-500 dark:border-blue-400',
    'border-emerald-500 dark:border-emerald-400',
    'border-purple-500 dark:border-purple-400',
    'border-orange-500 dark:border-orange-400'
  ]

  // Hover-only background and text accents
  const hoverAccents = [
    'hover:bg-blue-100 hover:dark:bg-blue-900/40 hover:text-blue-900 hover:dark:text-blue-100',
    'hover:bg-emerald-100 hover:dark:bg-emerald-900/40 hover:text-emerald-900 hover:dark:text-emerald-100',
    'hover:bg-purple-100 hover:dark:bg-purple-900/40 hover:text-purple-900 hover:dark:text-purple-100',
    'hover:bg-orange-100 hover:dark:bg-orange-900/40 hover:text-orange-900 hover:dark:text-orange-100'
  ]

  const i = index % 4

  return `${neutral} ${borderSchemes[i]} ${hoverAccents[i]}`
}

const handleClose = () => {
  if (!loading.value) {
    emit('close')
  }
}

const handlePreview = async () => {
  if (previewing.value) return

  try {
    previewing.value = true
    error.value = null
    
    // Create payload with custom module order
    const payload: CalibratePayload = {
      ...form.value,
      module_order: availableModules.value.map(module => module.module_id)
    }
    
    const response = await ModulesService.previewCalibration(payload)
    previewResults.value = response.data
  } catch (err: any) {
    error.value = err.message || 'Failed to preview calibration'
    previewResults.value = null
  } finally {
    previewing.value = false
  }
}

const handleSubmit = async () => {
  if (syncing.value) return

  try {
    syncing.value = true
    error.value = null
    
    // Create payload with custom module order
    const payload: CalibratePayload = {
      ...form.value,
      module_order: availableModules.value.map(module => module.module_id)
    }
    
    const response = await ModulesService.calibrateModules(payload)
    emit('success', response.message || 'Module time settings synced successfully')
    emit('close')
  } catch (err: any) {
    error.value = err.message || 'Failed to sync modules'
  } finally {
    syncing.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-visible": _ctx.isVisible,
    title: "Sync Module Time Settings",
    subtitle: "Automatically set up time schedules for all active modules",
    icon: _unref(RefreshCw),
    size: "4xl",
    type: "default",
    "show-footer": true,
    onClose: handleClose
  }, {
    footer: _withCtx(() => [
      _createVNode(BaseButton, {
        text: "Cancel",
        variant: "secondary",
        disabled: loading.value,
        onClick: handleClose
      }, null, 8, ["disabled"]),
      _createVNode(BaseButton, {
        text: "Sync",
        variant: "primary",
        icon: _unref(RefreshCw),
        loading: syncing.value,
        "loading-text": "Syncing...",
        disabled: loading.value,
        onClick: handleSubmit
      }, null, 8, ["icon", "loading", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(handleSubmit, ["prevent"]),
          class: "space-y-6"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(BaseInput, {
              modelValue: form.value.start_month,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.start_month) = $event)),
              label: "Start Month",
              type: "select",
              options: months,
              required: true
            }, null, 8, ["modelValue"]),
            _createVNode(BaseInput, {
              modelValue: form.value.start_year,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.start_year) = $event)),
              label: "Start Year",
              type: "select",
              options: _unref(yearOptions),
              required: true
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 dark:text-gray-300" }, " Module Order for Sync ", -1)),
                _createVNode(BaseButton, {
                  text: "Reset",
                  variant: "ghost",
                  size: "sm",
                  icon: _unref(RotateCcw),
                  loading: loadingModules.value,
                  "loading-text": "Loading...",
                  onClick: loadAvailableModules
                }, null, 8, ["icon", "loading"])
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400 mb-4" }, " Modules are ordered by their assigned time settings. Drag and drop to reorder if needed. The first module will be assigned to the start month, second to the next month, etc. ", -1)),
              (availableModules.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_unref(VueDraggable), {
                      modelValue: availableModules.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((availableModules).value = $event)),
                      animation: 200,
                      delay: _unref(isMobile) ? 600 : 0,
                      delayOnTouchStart: true,
                      ghostClass: "ghost",
                      chosenClass: "chosen",
                      dragClass: "drag",
                      class: "space-y-2"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableModules.value, (module, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: module.module_id,
                            class: "module-item group cursor-move p-3 bg-white dark:bg-gray-600 border border-gray-200 dark:border-gray-500 rounded-lg shadow-sm hover:shadow-md transition-all duration-200 hover:border-blue-300 dark:hover:border-blue-400"
                          }, [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_unref(GripVertical), { class: "h-5 w-5" })
                              ]),
                              _createElementVNode("div", _hoisted_9, _toDisplayString(index + 1), 1),
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("p", {
                                    class: "text-sm font-medium text-gray-900 dark:text-white truncate",
                                    title: module.name
                                  }, _toDisplayString(module.name), 9, _hoisted_12),
                                  (module.time_setting)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300",
                                        title: `Scheduled: ${formatModuleDateRange(module.time_setting.start_date, module.time_setting.end_date)}`
                                      }, [
                                        _createVNode(_unref(Calendar), { class: "h-4 w-4" })
                                      ], 8, _hoisted_13))
                                    : _createCommentVNode("", true)
                                ]),
                                (module.description)
                                  ? (_openBlock(), _createElementBlock("p", {
                                      key: 0,
                                      class: "text-xs text-gray-500 dark:text-gray-400 truncate",
                                      title: module.description
                                    }, _toDisplayString(module.description), 9, _hoisted_14))
                                  : _createCommentVNode("", true),
                                (module.time_setting)
                                  ? (_openBlock(), _createElementBlock("p", {
                                      key: 1,
                                      class: "text-xs text-blue-600 dark:text-blue-400 truncate mt-1",
                                      title: formatModuleDateRange(module.time_setting.start_date, module.time_setting.end_date)
                                    }, _toDisplayString(formatModuleDateRange(module.time_setting.start_date, module.time_setting.end_date)), 9, _hoisted_15))
                                  : _createCommentVNode("", true)
                              ]),
                              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                                _createElementVNode("span", { class: "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 dark:bg-green-900/50 text-green-800 dark:text-green-200" }, " Active ")
                              ], -1))
                            ])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "delay"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (loadingModules.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_unref(Loader2), { class: "h-5 w-5 animate-spin mr-2" }),
                          _cache[5] || (_cache[5] = _createTextVNode(" Loading available modules... ", -1))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_unref(Database), { class: "h-8 w-8 mx-auto mb-2 opacity-50" }),
                          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm" }, "No active modules found", -1)),
                          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-xs mt-1" }, "Click refresh to load modules", -1))
                        ]))
                  ]))
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "flex items-center gap-2 mt-8 mb-6" }, [
                _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 dark:text-gray-300" }, " Live Preview "),
                _createElementVNode("span", { class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300" }, [
                  _createElementVNode("span", { class: "w-1.5 h-1.5 bg-green-500 rounded-full mr-1" }),
                  _createTextVNode(" Auto-updates ")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("h4", _hoisted_21, [
                  (!previewing.value)
                    ? (_openBlock(), _createBlock(_unref(Eye), {
                        key: 0,
                        class: "h-4 w-4"
                      }))
                    : (_openBlock(), _createBlock(_unref(Loader2), {
                        key: 1,
                        class: "h-4 w-4 animate-spin"
                      })),
                  _cache[9] || (_cache[9] = _createElementVNode("span", null, "Sync Preview", -1)),
                  (previewing.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "(Updating...)"))
                    : _createCommentVNode("", true)
                ]),
                (previewResults.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "w-2 h-2 bg-blue-500 rounded-full" }, null, -1)),
                          _cache[11] || (_cache[11] = _createElementVNode("strong", null, "Total Modules:", -1)),
                          _createElementVNode("span", _hoisted_26, _toDisplayString(previewResults.value.total_modules), 1)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _cache[12] || (_cache[12] = _createElementVNode("span", { class: "w-2 h-2 bg-emerald-500 rounded-full" }, null, -1)),
                          _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Starting From:", -1)),
                          _createElementVNode("span", _hoisted_28, _toDisplayString(previewResults.value.start_month), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!previewResults.value && !previewing.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createVNode(_unref(Eye), { class: "h-6 w-6 mx-auto mb-2 opacity-50" }),
                      _cache[14] || (_cache[14] = _createElementVNode("p", { class: "font-medium" }, "Preview will appear here", -1)),
                      _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-xs mt-1" }, "Configure settings to see module assignments", -1))
                    ]))
                  : _createCommentVNode("", true),
                (previewData.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex items-center gap-2 mb-2" }, [
                        _createElementVNode("span", { class: "text-xs text-blue-600 dark:text-blue-400 font-medium" }, "Module assignments preview:")
                      ], -1)),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewData.value.slice(0, 44), (setting, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: _normalizeClass([
                            'text-xs px-3 py-2 rounded-md transition-colors duration-200 ease-in-out',
                            getPreviewItemClasses(index)
                          ])
                            }, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("span", {
                                  class: "font-medium truncate flex-1 min-w-0",
                                  title: setting.module_name
                                }, _toDisplayString(setting.module_name), 9, _hoisted_34),
                                _createElementVNode("span", {
                                  class: "text-xs opacity-80 ml-2 whitespace-nowrap flex-shrink-0",
                                  title: setting.month_year
                                }, _toDisplayString(setting.month_year), 9, _hoisted_35)
                              ])
                            ], 2))
                          }), 128)),
                          (previewData.value.length > 44)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, " ... and more assignments ... "))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_unref(AlertCircle), { class: "h-5 w-5 text-red-600 dark:text-red-400 mt-0.5 flex-shrink-0" }),
                  _createElementVNode("div", null, [
                    _cache[18] || (_cache[18] = _createElementVNode("h4", { class: "text-sm font-medium text-red-800 dark:text-red-200" }, "Error", -1)),
                    _createElementVNode("p", _hoisted_39, _toDisplayString(error.value), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 32)
      ])
    ]),
    _: 1
  }, 8, ["is-visible", "icon"]))
}
}

})